
import { 
    VERIFY_OTP,
    VERIFY_OTP_SUCCESS,
    VERIFY_OTP_FAIL, 
    VERIFY_OTP_RESET,
} from "../actions/verifyOtpAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const verifyOtpReducer = (state = initialState, action) => {
    switch (action.type) {
        case VERIFY_OTP:
            return {
                ...state,
                apiState: "loading",
            };
        case VERIFY_OTP_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case VERIFY_OTP_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case VERIFY_OTP_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default verifyOtpReducer;
